// src/data/testimonials.js
export const testimonials = [
    {
      name: "Annabella Clark",
      text: "Cassidy is an absolutely amazing photographer. She photographed my wedding, and we really loved the photos. She takes the most artistic, amazing shots. I feel like she got every photo we could have ever wanted and also so many more we would’ve never thought of. She made us so comfortable as well! She went above and beyond to make the day exactly what we wanted. I really don’t think we could have picked a better photographer. I can’t recommend her enough.",
      rating: 5,
      type: "Wedding Client"
    },
    {
      name: "Taylor Sexton",
      text: "She did my brother and his new wife’s engagement photos and then seeing her work, I contacted her to do photos of my husband and I for our second wedding anniversary. She is such an amazing photographer! She has such a great artistic eye and comes up with the best shots. I will be having her take photos of us again! HIGHLY RECOMMEND!!!!!",
      rating: 5,
      type: "Family Client"
    },
    {
      name: "Ashly Mcclave",
      text: "she's such a talented photographer and puts her heart and soul into every shoot she does. I can't recommend her enough!!",
      rating: 5,
      type: "Equine Client"
    }
  ];